import React, { useState, useEffect, useRef } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Paper from '@mui/material/Paper';

const styles = {
  placeholder: {
    color: '#7e7c8a',
    textAlign: 'left',
    font: 'normal normal normal 16px/22px Nunito',
    letterSpacing: 0,
    opacity: 1,
    top: 0,
    left: 0,
    display: 'inline-flex',
    position: 'relative',
  },
  dropdownIcon:{
    position: 'absolute',
    fontSize: '1.5rem',
    right: '7px',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.6)'
  },
  toggleField : {
    width: 'auto',
    padding: '16.5px 14px',
    border: '1px solid rgba(0, 0, 0, 0.6)',
    cursor: 'pointer',
    borderRadius: '4px',
    position: 'relative',
    minWidth: '160px',
  },
  paper : {
    zIndex: 5,
    position: 'absolute',
    background: '#FFFFFF',
    left: '0px',
  },
  dropdownList : { 
    listStyle: 'none', 
    padding: 0, 
    maxHeight: '200px', 
    overflowY: 'auto' }
};

function MultiSelect({
  type,
  required,
  error,
  label,
  disabled,
  onClick,
  placeholder = 'Select',
  textKey,
  selectorKey,
  data,
  action,
  tooltiptext,
  searchPlaceholder = 'Search',
  defaultValue
}) {
  const [optionValue, setOptionValue] = useState(defaultValue ? defaultValue : []);
  const [filteredOptions, setFilteredOptions] = useState(data);
  const [isOpen, setIsOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const tooltipData = document.getElementById('tooltipText')
  if(tooltipData) tooltipData.innerHTML = tooltiptext;
  const dropdownRef = useRef(null);

  useEffect(() => {
    const updatedFilteredOptions = data.filter((obj) =>
      obj[textKey]?.toLowerCase()?.includes(keyword?.toLowerCase())
    );
    setFilteredOptions(updatedFilteredOptions);
  }, [keyword]);

  useEffect(() => {
    if(filteredOptions !== null){
      setFilteredOptions(null);
      setFilteredOptions(data)
    }
  }, [data]);

  useEffect(() => {
    if(defaultValue) setOptionValue(defaultValue)
  }, [defaultValue])

  const toggleDropdown = () => {
    setIsOpen((prevState) => !prevState);
    setKeyword('');
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const handleClick = (e, option) => {
    let updatedSelectedOptions;
    if (optionValue.includes(option[selectorKey])) {
      updatedSelectedOptions = optionValue.filter(
        (sesaId) => sesaId !== option[selectorKey]
      );
    } else {
      updatedSelectedOptions = [...optionValue, option[selectorKey]];
    }
    onClick(updatedSelectedOptions);
    setOptionValue(updatedSelectedOptions)
  };

  return (
    <>
    <se-form-field
        label={label}
        type={type}
        block
        required={required}
        disabled={disabled}
        status={error?'error':''}
        label-align='left'
      >
        {action? <span className='labelIcon'><se-tooltip position='top'><se-icon slot='trigger' option='raised'>{action}</se-icon>
        <div id='tooltipText'></div></se-tooltip></span> : null}
      <div style={{position: 'relative'}} ref={dropdownRef}>
      <div
        style={styles.toggleField}
        onClick={toggleDropdown}
      >
        <label
          style={styles.placeholder}
        >
          {placeholder}
        </label>
        <ArrowDropDownIcon
          sx={{
            ...styles.dropdownIcon,
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </div>
      <Paper
        elevation={3}
        sx={styles.paper}
      >
        {isOpen && (
          <div>
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
            <ul style={styles.dropdownList}>
              {filteredOptions?.map((option) => (
                <li
                  style={{ display: 'flex', alignItems: 'center' }}
                  key={option[selectorKey]}
                  onClick={(e) => handleClick(e, option)}
                >
                  <input
                    type="checkbox"
                    id={`${option[selectorKey]}-checkbox`}
                    name={option[selectorKey]}
                    value={option[selectorKey]}
                    onChange={(e) => handleClick(e, option)}
                    checked={optionValue.indexOf(option[selectorKey]) > -1}
                    style={{ height:'20px', width:'20px'}}
                  />
                  <label htmlFor={option[selectorKey]} style={{ whiteSpace: 'nowrap' }}>
                    {option[textKey] ?? ''}
                  </label>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Paper>
      </div>
      </se-form-field>
      {error && (<span className='errorMsg'>{error}</span>)}
    </>
  );
}

export default MultiSelect;
